import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ReactSignatureCanvas from 'react-signature-canvas';

import { Box } from './Box';
import { Button } from './Button';
interface SignatureCanvasProps {
  width?: string;
  height?: string;
  className?: string;
  updateSignature: (signature: string) => void;
}

export const SignatureCanvas: React.FC<SignatureCanvasProps> = ({
  width = '500px',
  height = '200px',
  className = 'sigCanvas',
  updateSignature,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'business-waiver' });
  const sigPad = useRef<ReactSignatureCanvas>(null);
  const clear = () => {
    sigPad.current?.clear();
    updateSignature('');
  };

  const trim = () => {
    updateSignature(sigPad.current?.getTrimmedCanvas().toDataURL('image/png'));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        maxWidth: '100vw',
        minHeight: '55px',
        mb: 2,
      }}
    >
      <ReactSignatureCanvas
        ref={sigPad}
        penColor="black"
        backgroundColor="white"
        onEnd={trim}
        canvasProps={{
          className,
          style: {
            width,
            height,
            border: '1px solid var(--mui-palette-divider)',
            borderRadius: '8px',
            boxShadow:
              '0 5px 22px 0 rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.06)',
            marginBottom: '16px',
          },
        }}
      />
      <Button variant="outlined" color="primary" onClick={clear} sx={{ mt: 1 }}>
        {t('Reset Signature')}
      </Button>
    </Box>
  );
};
